export const MARKETING_ROUTES = {
  home: "/",
  about: "/about-us",
  contact: "/contact-us",
  pricing: "/pricing",
  privacy: "/privacy-policy",
  terms: "/terms-of-use",
  refund: "/cancellation-refund-policy",
  delivery: "/service-delivery-policy",
  demo: "/book-demo",
  login: "/login",
  register: "/registermodal",
  features: "/#feat-sec",
};

export const FOOTER_COMPANY_LINKS = [
  { label: "About Us", to: MARKETING_ROUTES.about },
  { label: "Contact Us", to: MARKETING_ROUTES.contact },
  { label: "Pricing", to: MARKETING_ROUTES.pricing },
];

export const FOOTER_LEGAL_LINKS = [
  { label: "Privacy Policy", to: MARKETING_ROUTES.privacy },
  { label: "Terms of Use", to: MARKETING_ROUTES.terms },
  { label: "Cancellation & Refund Policy", to: MARKETING_ROUTES.refund },
  { label: "Service Delivery Policy", to: MARKETING_ROUTES.delivery },
];

export const FOOTER_ALL_LINKS = [...FOOTER_COMPANY_LINKS, ...FOOTER_LEGAL_LINKS];

export const COMPANY = {
  name: "Brixigo",
  legalName: "Brixigo Technologies Private Limited",
  description:
    "Powerful HRMS and payroll technology designed to simplify workforce management for modern businesses.",
  email: "support@brixigo.com",
  hrEmail: "hr@brixigo.com",
  phone: "+91 83091 96410",
  phoneHref: "tel:+918309196410",
  address: "H. No. 13-4-38, Babu Camp, Bellampalli, Telangana – 504251, India",
  officeLines: [
    "H. No. 13-4-38, Babu Camp",
    "Bellampalli, Telangana – 504251",
    "India",
  ],
  locationShort: "Bellampalli, Telangana, India",
  focus: "HRMS & Payroll Technology",
};
